export default {
    wom: 'fa-home',
    wmo: 'fa-wheelchair',
    aom: 'fa-car',
    shop: 'fa-shopping-cart',
}



// WEBPACK FOOTER //
// ./scripts/web-components/municipality-picker-list/icons.js